import React from 'react';
import {Modal} from 'react-bootstrap';
import {ComponentUtils, DetailActions, OrganizationSelection, SwEmbeddedDetail, SwForm} from 'simplifyworks-core-ui';
import i18n from 'i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getElementAfter} from '../../utils';

const AcceptOrganOfferModal = (props) => {

	return (
		<>
			<Modal
				show={props.show}
				onHide={() => props.close()}
				size={'xl'}
			>
				<Modal.Header closeButton>
					<Modal.Title style={{width: 'auto'}}>
						{i18n.t('foedus-accept-organ-offer')}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<SwEmbeddedDetail
						name={'accept-organ-offer'}
						rest='/api/foedus/organ-offer/accept'
						restId={'new'}
						tabName={''}
						createButtonLabelKey={'foedus-accept-organ-offer'}
						newCallback={(actionResult, id, errorResponse) => {
							if (!errorResponse) {
								props.close();
								window.location.reload();
							}
						}}
					>
						<SwForm
							name={'accept-organ-offer'}
							rest={''}
							labelKey='foedus-accept-organ-offer'
							initialValue={{
								countryExpressingInterest: props?.loggedUserCountry || null,
								parentEntryId: props?.entryId
							}}
							valueChanged={(data, property, value, callback) => {
								callback(data);
							}}
						>
							<SwForm.Section>
								<SwForm.Entity
									size={12}
									writingEnabled
									preSelect
									disabled
									render={OrganizationSelection.renderText}
									property='countryExpressingInterest'
									labelKey={'foedus-country-expressing-interest'}
									validations='required'
								>
									{OrganizationSelection.renderSelection({
										name: 'foedus-organization',
										fixedFilter: {
											organizationTypes: props.countryCoreCodebook
												? [props.countryCoreCodebook]
												: []
										}
									})}
								</SwForm.Entity>
							</SwForm.Section>
						</SwForm>
					</SwEmbeddedDetail>
				</Modal.Body>
			</Modal>
		</>

	);
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		detail: bindActionCreators(DetailActions, dispatch)
	}
});

const mapStateToProps = (state, ownProps) => {
	const acceptOrganOfferFormData = ComponentUtils.getFormData(state, '/api/foedus/organ-offer/accept/new', 'DEFAULT');
	const pathSegments = state?.router?.location?.pathname?.split('/') || [];

	return {
		acceptOrganOfferFormData,
		countryCoreCodebook: state?.foedus?.countryCoreCodebook,
		loggedUserCountry: state?.foedus?.loggedUserCountry,
		entryId: getElementAfter(pathSegments, 'entries')
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AcceptOrganOfferModal);
